import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider, useDispatch, useSelector } from "react-redux";
import store from "./store/store";
import axios from "axios";
import { setDomains } from "./store/slice";
import { BASE_URL } from "./Service";
import DynamicHead from "./dynamic-head";

const root = ReactDOM.createRoot(document.getElementById("root"));
const urlParams = new URLSearchParams(window.location.search);
const host = urlParams.get("host") || window.location.hostname;

const Loader = () => (
  <div
    style={{
      height: "100vh",
      width: "100vw",
      overflow: "hidden",
      position: "fixed",
      left: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#ffffff",
      zIndex: 9999,
    }}
  >
    <div className="loader" />
    <style>
      {`
       .loader {
  color: #03228f;
  font-size: 10px;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  animation: mulShdSpin 1.3s infinite linear;
  transform: translateZ(0);
}

@keyframes mulShdSpin {
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 
    2em -2em 0 0em, 3em 0 0 -1em, 
    2em 2em 0 -1em, 0 3em 0 -1em, 
    -2em 2em 0 -1em, -3em 0 0 -1em, 
    -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 
    3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, 
    -2em 2em 0 -1em, -3em 0 0 -1em, 
    -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 
    2em -2em 0 0, 3em 0 0 0.2em, 
    2em 2em 0 0, 0 3em 0 -1em, 
    -2em 2em 0 -1em, -3em 0 0 -1em, 
    -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em,
     3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, 
     -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em,
     3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, 
     -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em,
     3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, 
     -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 
    3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, 
    -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 
    3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, 
    -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}
  
      `}
    </style>
  </div>
);

function AppWrapper() {
  const [AppComponent, setAppComponent] = useState(null);
  const dispatch = useDispatch();
  const domains = useSelector((state) => state.data.domains);
  const [loading, setLoading] = useState(true);

  const appLoaders = {
    theme1: async () => {
      const { default: App } = await import("./theme-1/src/app/App");
      await import("./theme-1/src/assets/scss/App.scss");
      // document.body.classList.add("theme1-font");
      return App;
    },
    theme2: async () => {
      const { default: App } = await import("./theme-2/src/app/App");
      await import("./theme-2/src/assets/scss/App.scss");
      // document.body.classList.add("theme2-font");
      return App;
    },
    theme3: async () => {
      const { default: App } = await import("./theme-3/src/App");
      await import("./theme-3/public/scss/main.scss");
      return App;
    },
    theme4: async () => {
      const { default: App } = await import("./theme-4/src/app/App");
      await import("./theme-4/src/assets/scss/App.scss");
      return App;
    },
    theme5: async () => {
      const { default: App } = await import("./theme-5/src/app/App");
      await import("./theme-5/src/assets/scss/App.scss");
      return App;
    },
    theme6: async () => {
      const { default: App } = await import("./theme-6/src/app/App");
      await import("./theme-6/src/assets/scss/App.scss");
      return App;
    },
    theme7: async () => {
      const { default: App } = await import("./theme-7/src/app/App");
      await import("./theme-7/src/assets/scss/App.scss");
      return App;
    },
    custom_theme: async () => {
      const { default: App } = await import("./custom_theme/src/app/App");
      await import("./custom_theme/src/assets/scss/App.scss");
      return App;
    },
    singlepage_theme: async () => {
      const { default: App } = await import("./singlepage_theme/src/app/App");
      // await import("./cust om_theme/src/assets/scss/App.scss");
      return App;
    },
  };

  useEffect(() => {
    const fetchDomains = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/v1/site/getDomains`);
        if (res.data.success) {
          dispatch(setDomains(res.data.data));
        }
      } catch (error) {
        console.error("Error fetching domains:", error);
      }
    };

    fetchDomains();
  }, [dispatch]);

  useEffect(() => {
    const matched = domains.find((site) => site.domainList.includes(host));

    const loadApp = async () => {
      // if (matched && appLoaders[matched.name]) {
      if (matched && matched.appliedTheme && appLoaders[matched.appliedTheme]) {
        // const App = await appLoaders[matched.name]();
        const App = await appLoaders[matched.appliedTheme]();

        setAppComponent(() => App);
      } else {
        alert("No matching domain");
      }
      setLoading(false);
    };

    if (domains.length > 0) {
      loadApp();
    }
  }, [domains, host]);

  if (loading || !AppComponent) return <Loader />;

  return <AppComponent />;
}

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <DynamicHead host={host} />
      <AppWrapper />
    </Provider>
  </BrowserRouter>,
);
